import * as actions from "./actionsType";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  criteriaLength: 0,
  criteria: [],
  criterion: {},
  criterionError: "",
  formError: "",
};

export default function CriterionReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_CRITERION:      
      return { ...state, loading: action.payload };

    case actions.LOADING_CRITERION_BY_ID:
      return { ...state, loadingById: action.payload };

    case actions.SAVE_LOADING_CRITERION:
      return { ...state, saveLoading: action.payload };

    case actions.GET_CRITERION:
      return {
        ...state,
        criteria: action.payload.criteria,
        criteriaLength: action.payload.criteriaLength,
      };

    case actions.GET_CRITERION_BY_ID:
      return { ...state, criterion: action.payload };

    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };

    case actions.CRITERION_FAIL:
      return { ...state, criterionError: action.payload };

    default:
      return state;
  }
}
